import React from "react";
import { useDispatch } from "react-redux";
/*import {
  configurationCleanSearchText,
  configurationSetSearchText,
  cleanSearchingConfigurationsPaginated,
  startSearchingConfigurationPaginated,
} from "../../app/actions/configurationActions";*/

import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import { catalogCiiuCleanSearchText, catalogCiiuSetSearchText, cleanSearchingCatalogCiiusPaginated, startSearchingCatalogCiiusPaginated } from "../../app/actions/catalogCiiuActions";

const SearchBackCatalogCiiu = ({ searchText, setSearchText, itemsPerPage, setIsDisabledSearchText, isDisabledSearchText, setIsDisabledFilter, isDisabledFilter }) => {
 //console.log("SearchBackCatalogCiiu");
  
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const onChangeInput = (event) => {
    setSearchText(event.target.value);

    if (event.target.value !== "") {
      setIsDisabledFilter(true);
      setIsDisabledSearchText(false);

      trackEvent({ component: "SearchCatalogCiius", event: "SearchCatalogCiius-Clicked", search: event.target.value });

      dispatch(catalogCiiuSetSearchText(event.target.value));

      dispatch(startSearchingCatalogCiiusPaginated(event.target.value, 0, itemsPerPage));
    } else {
      setIsDisabledFilter(false);
      setIsDisabledSearchText(false);
      
      dispatch(cleanSearchingCatalogCiiusPaginated());

      dispatch(catalogCiiuCleanSearchText());
    }
  };

  return (
    <div className="row height d-flex justify-content-center align-items-center">
      <div className="col-md-8">
        <div className="search">
          <i className="fa fa-search"></i>
          <input
            type="text"
            className="form-control"
            placeholder={t("general.option_search")}
            value={searchText}
            id="searchText"
            name="searchText"
            onChange={onChangeInput}
            disabled={isDisabledSearchText}
          ></input>
        </div>
      </div>
    </div>
  );
};

export default SearchBackCatalogCiiu;
